<template>
  <div>
    <b-card>
      <b-row>
        <b-col align-self="center">
          <b-form-group label-align="right" :label="$t('Service name')" label-cols="4" label-cols-xl="4" label-cols-md="4" disabled>
            <b-form-input type="text" v-model="currentService.service_name"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Sharge time')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="datetime-local" v-model="onceService.discount_date"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Cost %')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="number" v-model="onceService.cost_coef"/>
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>
    <b-row>
      <b-col>
        <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="saveServiceLink">Ok</b-button>
      </b-col>
      <b-col sm="3">
        <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click="hideSelectService">{{ $t('Cancel') }}</b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>

import moment from 'moment'
import axiosInstance from '@/utils/api.js'

export default {
  props: {
    currentUser: null,
    currentService: null,
    selectedAccount: null,
    isEdit: null,
    tariffLinkId: 0
  },
  data () {
    return {
      onceService: {
        'user_id': 0,
        'account_id': 0,
        'discount_date': moment().format('YYYY-MM-DDThh:mm'),
        'service_id': 0,
        'cost_coef': 100,
        'tplink_id': 0,
        'slink_id': 0
      }
    }
  },
  methods: {
    saveServiceLink () {
      this.onceService.cost_coef = this.onceService.cost_coef / 100
      this.onceService.discount_date = Number(Date.parse(this.onceService.discount_date)) / 1000
      this.onceService.tplink_id = this.tariffLinkId ? this.tariffLinkId : 0
      if (this.isEdit) {
        this.onceService.slink_id = this.currentService.service_link_id
        axiosInstance.put(this.$store.getters.API_USERS_SERVICELINKS_ONCE, this.onceService).then(response => {
          if (response.data.error) {
            this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
            this.onceService.cost_coef = this.onceService.cost_coef * 100
          } else {
            this.$root.$emit('makeToasts')
            this.$emit('hideSelectService')
            this.$emit('refreshTable')
          }
        })
      } else {
        this.onceService.account_id = this.selectedAccount
        this.onceService.user_id = this.currentUser.user_id
        this.onceService.service_id = this.currentService.service_id
        axiosInstance.post(this.$store.getters.API_USERS_SERVICELINKS_ONCE, this.onceService).then(response => {
          if (response.data.error) {
            this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
            this.onceService.cost_coef = this.onceService.cost_coef * 100
          } else {
            this.$root.$emit('makeToasts')
            this.$emit('hideSelectService')
            this.$emit('refreshTable')
          }
        })
      }
    },
    hideSelectService () {
      this.$emit('hideSelectService')
    },
    refreshTable () {
      this.$emit('refreshTable')
    },
    makeToasts (variant, body, title) {
      this.$root.$emit('makeToasts', variant, body, title)
    }
  },
  async mounted () {
    if (this.isEdit) {
      this.onceService = await axiosInstance.get(this.$store.getters.API_USERS_SERVICELINKS_ONCE + '?slink_id=' + this.currentService.service_link_id).then(response => { return response.data })
      this.onceService.discount_date = moment(Number(this.onceService.discount_date) * 1000).format('YYYY-MM-DDThh:mm')
      this.onceService.cost_coef = this.onceService.cost_coef * 100
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/detail/serviceLinks/formOnce.vue